var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1387_18609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8335 13.3332L10.5002 9.9999M10.5002 9.9999L7.16688 13.3332M10.5002 9.9999V17.4999M17.4919 15.3249C18.3047 14.8818 18.9467 14.1806 19.3168 13.3321C19.6868 12.4835 19.7637 11.5359 19.5354 10.6388C19.307 9.7417 18.7865 8.94616 18.0558 8.37778C17.3251 7.80939 16.4259 7.50052 15.5002 7.4999H14.4502C14.198 6.52427 13.7278 5.61852 13.0752 4.85073C12.4225 4.08295 11.6042 3.47311 10.682 3.06708C9.75967 2.66104 8.75734 2.46937 7.75031 2.50647C6.74328 2.54358 5.75777 2.80849 4.86786 3.28129C3.97795 3.7541 3.2068 4.42249 2.6124 5.23622C2.01799 6.04996 1.61579 6.98785 1.43603 7.9794C1.25627 8.97095 1.30363 9.99035 1.57456 10.961C1.84548 11.9316 2.33291 12.8281 3.00021 13.5832",
    stroke: "#FAFAFA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1387_18609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.d9670af4a84e186cb018dc044a39e0ca.svg";
export { ForwardRef as ReactComponent };